<div class="flex flex-col items-center w-screen h-screen bg-chathams-blue">
  <div class="max-w-xl">
    <img src="assets/images/logo-login.png" alt="Olive logo" />
  </div>

  <div class="w-96 text-center">
    <h1 class="mt-6 text-lg text-white">Redefinição de Senha</h1>
    <p class="mt-10 text-base leading-5 text-center text-white">
      Vamos redefinir sua senha! Por favor, insira a nova senha abaixo:
    </p>
  </div>

  <form class="mx-2 w-96" [formGroup]="resetPasswordForm" (ngSubmit)="setPassword()">
    <input class="mt-4 text-center form-input-custom" type="password" placeholder="Senha" formControlName="password" />

    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.password.touched && field.password.errors?.minlength"
    >
      A senha deve ter pelo menos 6 caracteres.
    </p>
    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.password.touched && field.password.errors?.hasNumber"
    >
      A senha deve conter pelo menos um número.
    </p>
    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.password.touched && field.password.errors?.hasCapitalCase"
    >
      A senha deve conter pelo menos uma letra maiúscula.
    </p>
    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.password.touched && field.password.errors?.hasSmallCase"
    >
      A senha deve conter pelo menos uma letra minúscula.
    </p>
    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.password.touched && field.password.errors?.hasSpecialCharacters"
    >
      A senha deve conter pelo menos um caractere especial. (!*&#64;#$%^&+=)
    </p>

    <input
      class="mt-4 text-center form-input-custom"
      type="password"
      placeholder="Confirmar Senha"
      formControlName="passwordConfirm"
    />

    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.passwordConfirm.touched && field.passwordConfirm?.value == ''"
    >
      Confirmar senha é obrigatório
    </p>

    <p
      class="px-1 mt-1 text-sm leading-3 text-center text-cerise-red"
      *ngIf="field.passwordConfirm.touched && field.passwordConfirm.errors?.passwordMismatch"
    >
      As senhas não coincidem.
    </p>

    <button type="submit" class="w-full h-10 mt-4 btn btn--secondary">Definir Nova Senha</button>
  </form>
</div>
